function BootleggersLogo() {
  return (
    <img
      height="200"
      width="200"
      src="/logos/bootleggers-logo.png"
      className="w-full h-full object-contain invert"
      alt="Bootleggers Logo"
      loading="eager"
      decoding="async"
    />
  );
}

export { BootleggersLogo };
